export const SET_USER_DETAILS = 'setUserDetails';
export const SET_AUTH_STATE = 'setAuthState';
export const LOGOUT_USER = 'logoutUser';
export const SET_USER_PACKAGE = 'setUserPackage';

export const CUSTOMER_SET_STATE = 'customerSetState';
export const CUSTOMER_SET_FETCH_STATUS = 'customerSetFetchStatus';
export const CUSTOMER_SET_TRANSLATIONS = 'customerSetTranslations';

export const PARTNER_SET_STATE = 'partnerSetState';
export const PARTNER_SET_FETCH_STATUS = 'partnerSetFetchStatus';
export const PARTNER_SET_FILTERS = 'partnerSetFilters';
export const PARTNER_SET_LISTREQUEST = 'partnerSetListRequest';

export const TRANSLATIONS_SET_STATE = 'translationsSetState';

export const SYSCONFIG_SET_NUTRIENT_SOURCES = 'sysConfigSetNutrientSources';
export const SYSCONFIG_UPDATE_NUTRIENT_SOURCE = 'sysConfigUpdateNutritionSource';
